module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mark of Evil ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0017-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#nc3",
      "id": "cn3"
    }
  }, [_c('b', [_vm._v("THREE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("When Ethan arrived at the large rock outcropping near the ancient ruins of the Acropolis, Louder and Gikas were there, along with a big, ominous-looking “assistant” who Ethan took to be the bodyguard. Gikas, a short, stocky man with bushy eyebrows, announced that he was the local agent for Jo Li, the reputed mastermind behind an underground network for buying and selling. But Gikas looked distracted. He kept nervously scanning the sky. When Ethan started to dialogue, Gikas put up his hand to silence him. Gikas craned his head quickly back and forth, surveying the Acropolis. After a moment he said, “I thought I heard one of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“One what?” Ethan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“One of those Global Alliance drone-bots they use for flyovers. Very little armed security on the ground here in the ruins.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’ve noticed that,” Louder said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, now they are doing it from the air,” Gikas continued. “They use the drones for nontaggers like you guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas launched into a diatribe on the problems that global surveillance had created. Everyone—and especially Ethan—knew what Gikas was talking about. Ethan didn’t need a lecture on the dilemma of nontaggers who, like his own group, had refused to receive a BIDTag—the invisible, biological identification tattoo with a hidden QR code, required by force of law to be lasered onto the backs of hands or on the foreheads of every citizen on the planet, including those in America. People had been told it was for homeland security purposes. But with the onslaught of global depression, the BIDTag had been converted for another use as a human debit card—a cashless, worldwide electronic system for payment and banking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When they’d worked shoulder to shoulder in Israel, Josh Jordan had continually drilled Ethan on the significance of those events. Josh kept reminding his younger apprentice how it fit into the tapestry of Bible prophecy. So when Josh and his family were raptured, Ethan was already trained to understand “the signs of the times,” as Josh would put it: the geopolitical events happening around the world and in the United States. Like the fact that the United States Congress had voted to join the world’s universal payment scheme, but President Hank Hewbright had promptly vetoed it. Then Congress overrode his veto in a squeaker of a vote. That’s where matters still stood in America. Appeals to the Supreme Court had been fruitless; the vanishing of several Supreme Court justices at the Great Disappearance meant a weakened high court, with several members missing and President Hewbright unable to get any of his judicial nominees confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Standing there in the shadow of the huge rock outcropping, Gikas was going on and on about the robotically operated drone planes that had been employed by the Global Alliance for surveillance and police work. “If they scan you from the air and don’t see your BIDTag, you get one warning over the loudspeaker from the drone, telling you to stop and to wait for someone to arrive on the ground to arrest you. A second warning if you don’t stop. Then they start shooting from the air.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan nodded. This was old news for him. Except that he knew something Gikas didn’t: for Ethan there would be no second warning, or even a first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah,” Louder replied. “We’re pretty up on all of that.” He gave a knowing glance at Ethan. Both of them knew that because Ethan was a leader of the resistance, his image had been cataloged into the facial-recognition program of the Global Alliance ID data centers—the main one in New Babylon, Iraq, and the others in Rome, London, Frankfurt, and Singapore—and they were all digitally linked and uploaded to the drone-bots around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas concluded his point. “Just have to be careful. Need to keep an eye on the sky.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The drone-bots have a recognizable pitch to the engines,” Ethan said. “I can usually hear them coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Anyway,” Gikas went on, “let’s get back to why you’re here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan jumped to his main point. He explained how he needed assurance that if his Remnant followers joined Jo Li’s underground economy they would not be linked to anything criminal. No dirty money. No tie-in to drugs, prostitution, human trafficking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas stretched out his arms in wonder. “What kind of people do you take us for?” He laughed loudly and so did his bodyguard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ethan March is a guy with principles,” Louder said. “I thought you knew that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay, okay,” Gikas replied. “I know about you people. Goody-good. Nicey-nice. All squeaky clean and talking all about God and Jesus. Which is why I’m happy to tell you that our trading system is completely legit. The people who trade back and forth in our system are just people who didn’t get BIDTagged, and so they need to be able to buy and sell some other way. Jo Li’s system is legal because he found a loophole in the law.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I need to see how his financial system actually operates,” Ethan said. “I need more information.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“For that, you will have to talk to Mr. Jo Li himself,” Gikas said. ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not here,” Gikas replied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Close?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not very. Hong Kong.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan took a moment to consider that. Then he asked something very different. “Tell me, Gikas, do you believe in God?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Louder smiled as if he wasn’t surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas answered, “Sure. Yeah. Why not.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You don’t sound very convinced,” Ethan said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas winked at his bodyguard as he answered. “It’s just that, you know, there’s a lot of unknowns.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan asked, “Do you know anything about this huge rock we’re standing next to?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas took a step toward the historical marker attached to the outcropping and eyed it. “Yeah, something about Paul the apostle doing something here. Some religious thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan began to explain how two thousand years ago, at that exact spot, Paul had told the great philosophers of ancient Athens about the God who had been unknown to them but could be known through His Son, Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The big bodyguard shuffled his feet and nudged Gikas, motioning with his head, like it was time to leave. But Gikas took a second to study Ethan. “You people are a strange bunch,” he said and thrust an index finger toward Ethan. “I’m going to have to figure you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Will you arrange the meeting with Jo Li?” Louder asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe,” Gikas said with a shrug. “It’s up to him, not me. He’s the big guy. I’m a nobody.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wrong,” Ethan said with a smile. “God thinks you’re somebody.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas was about to reply, but now Ethan hushed him as he held a finger to his lips. He gazed straight up. “There’s a drone-bot approaching. I can hear it.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("A second later they were all eyeing the sky. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ethan searched for somewhere to hide. The high mount of the Acropolis was too far away. He would never make it. Down toward the city? That was a mile at least to the nearest building. Probably more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now they could see the clean white underbelly of the drone approaching their position.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re exposed!” Ethan yelled. He pointed to the grove of trees off to the side of Mars Hill. “Head to the trees.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gikas yelled back, “They’ve got body sensors. They can still scan us in the woods.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As he started racing toward the trees, still limping slightly, Ethan explained, “But the bullets may get blocked by the trees!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He watched the drone dropping in altitude over their position. Then the laser orb on the belly of the unmanned attack plane flashed. On the ground Ethan was bathed with red light. “I’ve been painted!” he cried. “Everyone scatter. Get away from me!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ethan!” was all Louder had time to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A mere three seconds later—just enough time for the onboard computer in the drone to recognize Ethan from the sky—bullets from the fifty-caliber gun in the drone’s belly turret started blasting down at him. He yelled to Louder as he kept running clumsily toward the grove of trees. “Jimmy, get out of here! Meet me back at the apartment. Gikas, make the arrangements for the meeting with Jo Li.” Pistoning toward a full run as bullets exploded around him, he ducked inside the small wooded area. The bullets ripped through the treetops.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He found a large tree and wrapped his arms around the trunk, pressing against it as hard as he could, and waited. He could still hear the drone up in the sky, cruising back and forth over the trees. He glanced at his Allfone watch. The usual protocol was a seventeen-minute gunnery pursuit, and then the drones usually departed if they hadn’t confirmed a hit on their target. The only thing he could do now was wait it out and not move a muscle.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("He stood absolutely still, pressed against the rough bark of the olive tree, until he heard the sound of the plane’s engine fading. Finally the drone was no longer visible in the sky. He let go of the tree and breathed. And breathed again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Thank You, God")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But he couldn’t relax. Not yet. He had to get out of Athens. He knew that in a matter of minutes the plaza around Mars Hill would be crawling with Global Alliance police forces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As he made his way down the hill, he had another thought. "), _c('i', [_vm._v("So much for taking me alive.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f513db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 75
// module chunks = 0